module.exports = __webpack_public_path__ + "img/16d001-41.590effe1.jpg";